import { styled } from "@mui/material/styles";
import theme, { mobileTypography } from "src/config/theme";
import { palette, shadows, typography } from "src/config/theme";
import { Avatar, Box, Chip, Typography, alpha } from "@mui/material";
export const HistoryContainerOne = styled(Box)({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    marginBottom: '30px',
    position: 'fixed',
    // zIndex: 1000,
    [theme.breakpoints.down('md')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        padding: '12px auto',
        position: 'relative',
        marginBottom: '0'
    },
});
export const Texts = styled(Typography)({
    ...typography.h5,
    color: palette.gery.black,
    [theme.breakpoints.down('md')]: {
        ...mobileTypography.h6
    }
})
export const InnerContainer = styled(Box)({
    width: '582px',
    height: '52px',
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: '8px',
        width: '100%',
        height: 'auto'
    }
})




export const HistoryWrapper = styled(Box)({
    height: 'calc(100vh - 450px)',
    overflow: 'hidden',
    marginTop: '82px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
        marginTop: '40px',
        marginBottom: '40px',
    }

});
export const HistoryContainerTwo = styled(Box)({
    width: '661px',
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '8px', // optional to avoid scrollbar overlapping content
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: alpha(palette.primary.main, 0.5),
        borderRadius: '8px',
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
    }
});
export const FirstRow = styled(Box)({
    width: 'auto',
    height: '670px',
    display: 'flex',
    flexDirection: 'row'
});
export const LabelText = styled(Box)({
    width: '146px',
    height: '22px',
    [theme.breakpoints.down('md')]: {
        width: 'auto'
    }
})

export const Label = styled(Typography)({
    ...typography.h5,
    color: `${alpha(palette.gery.black, 0.7)}`,
    textWrap: 'nowrap',
    [theme.breakpoints.down('md')]: {
        ...mobileTypography.body1,
        textWrap: 'wrap',
    }
})

export const Headers = styled(Typography)({
    ...typography.h4,
    color: palette.gery.black,
    fontWeight: '500',
    [theme.breakpoints.down('md')]: {
        ...mobileTypography.h6,
    }

})

export const Paragraph = styled(Typography)({
    ...typography.smallRegular,
    color: `${alpha(palette.gery.black, 0.7)}`,
    lineHeight: '24px',
    [theme.breakpoints.down('md')]: {
        ...mobileTypography.small,
    }
})

export const Border = styled(Box)({
    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
    position: 'relative',
    zIndex: 0

})
export const CircleContainer = styled(Box)({
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: palette.primary.light3,
    position: 'absolute',
    left: '-13px'
})
export const CircleInner = styled(Box)({
    width: '16px',
    height: '16px',
    backgroundColor: palette.primary.main,
    borderRadius: '50%',
})
export const Details = styled(Box)({
    width: 'auto',
    display: 'flex',
    flexDirection: 'row',
    gap: '40px',
})
export const HeaderTextContainer = styled(Box)({
    width: '486px',
    height: '150px',
    display: 'flex',
    flexDirection: 'row',
    gap: '25px',
    position: 'relative',

})
export const HeaderText = styled(Box)({
    // width: '486px',
    // height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',

})
